export default "__VITE_ASSET__CCT5crdr__"